import { Box, IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import PersonIcon from "@mui/icons-material/Person";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLocalItem, removeLocalItem } from "../../util/helper";
import { API_ENDPOINT_URL } from "../../util/api";
import axios from "axios";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import GroupIcon from '@mui/icons-material/Group';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import { Link } from 'react-router-dom';

const isSupperUser = JSON.parse(localStorage.getItem("is_superuser"))
const isStaff = JSON.parse(localStorage.getItem("is_staff"))

const Topbar = ({ onHandleDrawerOpen, handleDrawerOpen, isAdmin }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    handleClose();
    const token = getLocalItem("key");
    axios
      .get(`${API_ENDPOINT_URL}/master/logout`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        removeLocalItem("key");
        removeLocalItem("is_superuser");
        removeLocalItem("is_staff");
        setTimeout(() => {
          navigate("/login");
        }, 500);
      })
      .catch((error) => {
        // handle the error
        console.log(error);
      });
  };

  const handleUserListClick = () => {
    handleClose();

    setTimeout(() => {
      navigate("/user-list");
    }, 500);
  };

  const handlePasswordResetClick = () => {
    handleClose();
    setTimeout(() => {
      navigate("/reset-password");
    }, 500);
  };

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <>


      <Box
        display="flex"
        justifyContent="space-between"
        padding="10px 20px"
        backgroundColor="#36454F"
      >
        <Box
          display="flex"
          alignItems="center"
          color="#fff"
          // fontWeight="bold"
          fontSize="35px"
        >
          {isAdmin?<IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            sx={{ ...open, marginRight: "5px" }}
          >
            <MenuIcon style={{ fontSize: "3rem" }} />
          </IconButton>:""}
          <Link to="/">
          <img
            src={process.env.PUBLIC_URL + '/logo.png'} 
            alt="PhishDetector Logo"
            style={{ height: '55px', marginRight: '5px' }}
          />
          </Link>
        </Box>
        <Box>
          <IconButton
            sx={{ position: "relative" }}
            onClick={handleClick}
            aria-controls={isOpen ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={isOpen ? 'true' : undefined}
          >
            <PersonIcon sx={{ color: "white", fontSize: "50px" }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={isOpen}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            {isAdmin ? (
              <>
                <MenuItem onClick={handleUserListClick}>
                  <ListItemIcon>
                    <GroupIcon frontSize="small" />
                  </ListItemIcon>
                  User List
                </MenuItem>
                <Divider />
              </>
            ) : null}
            <MenuItem onClick={handlePasswordResetClick}>
              <ListItemIcon>
                <SyncLockIcon frontSize="small" />
              </ListItemIcon>
              Password Reset
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </>
  );
};

export default Topbar;
